export default "__VITE_ASSET__dD2u3oo3__"